import { ROOT, SUPPLIER_GET_ALL_SITE, SUPPLIER_LOGIN, UPDATE_INDEX, SUPPLIER_GET_ALL_HOTEL } from "@/_helpers/constant.js";

import { requestOptions, handleResponse } from "@/_helpers";

function getHotel(body) {
    return fetch(ROOT + SUPPLIER_GET_ALL_HOTEL, requestOptions.post(body))
        .then(handleResponse)
        .then(data => {
            return data;
        });
}
function getSite(body) {
    return fetch(ROOT + SUPPLIER_GET_ALL_SITE, requestOptions.post(body))
        .then(handleResponse)
        .then(data => {
            return data;
        });
}
function login(hotelId) {
    return fetch(ROOT + SUPPLIER_LOGIN + `/${hotelId}`, requestOptions.get())
        .then(handleResponse)
        .then(data => {
            return data;
        });
}
function updateIndex(body) {
    return fetch(ROOT + UPDATE_INDEX, requestOptions.post(body))
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

export const hotelService = {
    getSite,
    login,
    updateIndex,
    getHotel
};
